import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoTarefa } from 'src/app/models/enum';
import { FilaTarefa } from 'src/app/models/filas/fila-tarefa';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FilaTarefaService } from 'src/app/services/fila-tarefa.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-historico-modal',
  templateUrl: './historico-modal.component.html',
  styleUrls: ['./historico-modal.component.scss']
})
export class HistoricoModalComponent implements OnInit, OnChanges {

  @Input() idCupom: string;
  @Input() podeSelecionar: boolean;
  @Input() idTarefaSelecionada: number;
  @Output() selecionouTarefa = new EventEmitter();

  tarefasDoPedido: FilaTarefa[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(private carregandoService: CarregandoService, private filaTarefaService: FilaTarefaService,
    private notificacaoService: NotificacaoService
  ) { }

  ngOnInit() {
    this.buscarTarefasDoPedido();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buscarTarefasDoPedido();
  }

  buscarTarefasDoPedido() {
    this.carregandoService.mostra('buscarTarefasDoPedido');
    this.filaTarefaService.consultarTarefasDoPedido(this.idCupom, TipoTarefa.MonitorConferencia).subscribe(dados => {
      this.tarefasDoPedido = dados;
      this.carregandoService.esconde('buscarTarefasDoPedido');
    }, (erro) => {
      this.carregandoService.esconde('buscarTarefasDoPedido');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarTarefa(idTarefa) {
    this.selecionouTarefa.emit(idTarefa);
  }
}
